import { render, staticRenderFns } from "./AllStories.vue?vue&type=template&id=1c196b35"
import script from "./AllStories.vue?vue&type=script&lang=js"
export * from "./AllStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports